document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('header-menu').forEach(function (menu) {
      var details = menu.querySelector('details.mega-menu');
      if (!details) return;

      var closeTimeout;

      menu.addEventListener('mouseenter', function () {
        clearTimeout(closeTimeout);
        details.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', function () {
        closeTimeout = setTimeout(function () {
          details.removeAttribute('open');
        }, 150);
      });
    });
  });